import React from "react";
import SlDialog from "@shoelace-style/shoelace/dist/react/dialog";
import SlIcon from "@shoelace-style/shoelace/dist/react/icon";
import ButtonOutline from "../reusable/ButtonOutline/ButtonOutline";
import Button from "../reusable/Button/Button";
import "./ModalSelectSyncMode.css";

interface Props {
  show: boolean;
  tabla: string;
  onClose: () => void;
  onConfirmClassic: () => void;
  onConfirmUpsertHash: () => void;
}

/**
 * Modal para elegir el modo de sincronización de una tabla mirror que
 * soporta tanto el flujo clásico (delete + insert por lotes) como el
 * flujo upsert-hash (aplica altas, modificaciones y bajas por hash).
 */
function ModalSelectSyncMode({
  show,
  tabla,
  onClose,
  onConfirmClassic,
  onConfirmUpsertHash,
}: Props) {
  return (
    <SlDialog
      label={`Sincronizar ${tabla}`}
      open={show}
      onSlAfterHide={onClose}
      className="shoelace-modal modal-select-sync-mode"
      // @ts-ignore
      style={{ "--width": "620px" }}
    >
      <div className="select-sync-container">
        <p className="select-sync-subtitle">
          Esta tabla soporta dos modos de sincronización. Elegí cómo procesarla:
        </p>

        <div className="select-sync-options">
          <div className="select-sync-option">
            <div className="select-sync-option-header">
              <SlIcon name="lightning-charge" className="select-sync-icon" />
              <span className="select-sync-option-title">Upsert Hash</span>
              <span className="select-sync-badge select-sync-badge-recommended">
                Recomendado
              </span>
            </div>
            <p className="select-sync-option-text">
              No elimina los registros existentes. Usa un hash por registro
              para detectar y aplicar solo <strong>altas</strong>,{" "}
              <strong>modificaciones</strong> y <strong>bajas</strong>, más
              procesamiento post-sync.
            </p>
            <Button
              label="Sincronizar con Upsert Hash"
              iconName="arrow-repeat"
              theme="primary"
              onClick={onConfirmUpsertHash}
              className="select-sync-btn"
            />
          </div>

          <div className="select-sync-option">
            <div className="select-sync-option-header">
              <SlIcon name="arrow-repeat" className="select-sync-icon" />
              <span className="select-sync-option-title">Clásico</span>
              <span className="select-sync-badge select-sync-badge-warning">
                Reemplazo total
              </span>
            </div>
            <p className="select-sync-option-text">
              Elimina todos los registros de la tabla mirror y los inserta de
              nuevo por lotes. Flujo tradicional; útil ante inconsistencias
              graves.
            </p>
            <Button
              label="Sincronizar clásico"
              iconName="arrow-repeat"
              theme="yellow"
              onClick={onConfirmClassic}
              className="select-sync-btn"
            />
          </div>
        </div>

        <div className="select-sync-footer">
          <ButtonOutline
            label="Cancelar"
            variant="neutral"
            onClick={onClose}
          />
        </div>
      </div>
    </SlDialog>
  );
}

export default ModalSelectSyncMode;
